/**
 * Billing Context
 *
 * Provides shared billing state (credits, account, plans) with TTL caching.
 */

import type { ReactNode } from "react";
import { useBillingCache } from "./hooks/useBillingCache";
import { BillingContext } from "./contexts/billing/context";

export interface BillingProviderProps {
  children: ReactNode;
  autoFetch?: boolean;
  requireAuth?: boolean;
}

export function BillingProvider(
  { children, autoFetch = true, requireAuth = false }: BillingProviderProps,
) {
  const value = useBillingCache({ autoFetch, requireAuth });

  return (
    <BillingContext.Provider value={value}>{children}</BillingContext.Provider>
  );
}
